import { ConfigProvider, Input } from "antd";
import { Colors } from "../../config";

const CodeInput = ({
  onChange,
  value,
  type = "text",
  length = 4,
  disabled = false,
  size = "large",
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            activeBorderColor: Colors.main,
            hoverBorderColor: Colors.main,
          },
        },
      }}
    >
      <Input.OTP
        length={length}
        disabled={disabled}
        size={size}
        type={type}
        onChange={onChange}
        classNames="custom-otp-input"
        {...props}
      />
    </ConfigProvider>
  );
};
export default CodeInput;
